import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import Pagination from "@/components/Pagination.vue";
import { reactive, toRefs, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import bus from "@/utils/eventBus.js";
import apis from "@/api";
export default {
  components: {
    Pagination
  },
  setup() {
    const router = useRouter();
    const data = reactive({
      tableData: [],
      selectedIds: [],
      name: "",
      pageNo: 1,
      total: 0,
      loading: true
    });
    const route = useRoute();
    const fetchData = favId => {
      apis.queryFavoriteBiz(favId, data.name, data.pageNo, 20).then(res => {
        if (res.success) {
          data.tableData = res.data.records;
          data.total = res.data.total;
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    watch(() => {
      var _route$query;
      return (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.favId;
    }, favId => {
      if (favId) {
        fetchData(favId);
      }
    }, {
      immediate: true
    });
    const selectionChange = val => {
      data.selectedIds = val.map(i => i.id);
    };
    const queryHandler = () => {
      var _route$query2;
      fetchData((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.favId);
    };
    const rowClick = row => {
      router.push(`/assets-lib/detail/${row.dataId}`);
    };
    const deleteHandler = () => {
      ElMessageBox.confirm("确定要删除选中的收藏夹吗？").then(() => {
        apis.delFavorites(data.selectedIds.join(",")).then(() => {
          ElMessageBox({
            message: "删除成功！",
            type: "success"
          });
          data.tableData = data.tableData.filter(i => {
            return !data.selectedIds.includes(i.id);
          });
          bus.emit("collection-refresh");
        });
      }).catch(() => {});
    };
    return {
      ...toRefs(data),
      selectionChange,
      deleteHandler,
      queryHandler,
      rowClick
    };
  }
};